import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Brochure from './pages/Brochure';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brochure" element={<Brochure />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
